import { render } from "./CloseSesionIcon.vue?vue&type=template&id=52c86fd5"
import script from "./CloseSesionIcon.vue?vue&type=script&lang=js"
export * from "./CloseSesionIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__